export interface MailPanelPreference {
  /** Also the last expanded width while the list is collapsed. */
  listWidth: number;
  sourceShare: number;
  collapsed: boolean;
}

const DEFAULT_MAIL_PREFERENCE: Readonly<MailPanelPreference> = {
  listWidth: 280, sourceShare: 0.45, collapsed: false,
};

export function mailPanelPreferenceKey(userId: string | null): string | null {
  return userId ? `reqventos.mail-layout.${encodeURIComponent(userId)}` : null;
}

export function parseMailPanelPreference(raw: string | null): MailPanelPreference | null {
  try {
    const value = JSON.parse(raw ?? "null");
    if (!value || typeof value !== "object" || Array.isArray(value)
      || Object.keys(value).sort().join(",") !== "collapsed,listWidth,sourceShare,version"
      || value.version !== 1 || typeof value.collapsed !== "boolean"
      || !Number.isFinite(value.listWidth) || value.listWidth <= 0
      || !Number.isFinite(value.sourceShare) || value.sourceShare <= 0 || value.sourceShare >= 1) return null;
    return { listWidth: value.listWidth, sourceShare: value.sourceShare, collapsed: value.collapsed };
  } catch {
    return null;
  }
}

export function readMailPanelPreference(userId: string | null): MailPanelPreference {
  try {
    const key = mailPanelPreferenceKey(userId);
    if (key) {
      const stored = parseMailPanelPreference(window.localStorage.getItem(key));
      if (stored) return stored;
    }
  } catch { /* Storage is optional, including access to the localStorage property. */ }
  return { ...DEFAULT_MAIL_PREFERENCE };
}

export function saveMailPanelPreference(userId: string | null, value: MailPanelPreference): void {
  try {
    const key = mailPanelPreferenceKey(userId);
    if (!key) return;
    // Explicitly project the presentation fields; never serialize a session or request.
    const raw = JSON.stringify({ version: 1, listWidth: value.listWidth,
      sourceShare: value.sourceShare, collapsed: value.collapsed });
    if (parseMailPanelPreference(raw)) window.localStorage.setItem(key, raw);
  } catch { /* A blocked/full store must not prevent a layout interaction. */ }
}
